import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { SET_RECEIVER_ID } from 'src/store/balanceShow/types'

type Props = {
  value: string
  type: 'source' | 'destination'
  code: string
}

const TransactionsUserCell: React.FC<Props> = ({value, type, code}) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
  const handleClick = () => {
     dispatch({type: SET_RECEIVER_ID, payload: code})
           

           navigate('/report/party-ledger');
  }

  return (
    <span onClick={handleClick} style={{cursor: 'pointer', color: 'blue',textDecoration:"underline" }}>
      {value}
    </span>
  )
}

export default TransactionsUserCell
